import React from 'react';
import PriceDisplay from './priceDisplay';

const Summary = ({event, selectedOptions, userAddress, boothInfo, basePrice }) => {
    let months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
    let dateString = `${event.eventDate.getDate()} ${months[event.eventDate.getMonth()]} ${event.eventDate.getFullYear()}`;
    let totalPrice = selectedOptions.reduce((total, current) => {
        return total + current.price;
    }, basePrice);

    const renderOptions = () => {
        return selectedOptions.map((item) => {
            return item.title;
        }).join(', ')
    };
    return (
        <div>
            <h4 className="step--active">Stap 4: Bevestig en feest!</h4>
            <p>
                Je huurt de <strong>{boothInfo.name}</strong> op {dateString}.
                De totaalprijs is <strong><PriceDisplay price={totalPrice} /></strong> incl. btw.
            </p>
            <p>
                Je hebt <strong>{ selectedOptions.length > 0 ? selectedOptions.length : 'geen'} </strong>
                {selectedOptions.length === 1 ? 'optie' : 'opties' } gekozen{selectedOptions.length > 0 ? ` (${renderOptions()})` : null }.
            </p>

            {userAddress &&
            <p>
                        <span>
                            We sturen een bevestiging van deze reservering naar naar: <strong>{userAddress}</strong>
                        </span>
            </p>
            }
            <p>
                Kostenloze annulering van deze reservering is mogelijk tot 72 uur voor aanvang van evenement.
            </p>
        </div>
    );
};

export default Summary;


// WEBPACK FOOTER //
// ./src/components/reservationForm/summary.js